<template>
  <svg
    width="21"
    height="32"
    viewBox="0 0 21 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_963_28481"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="32"
    >
      <path
        d="M20.7746 0H0.224609V32H20.7746V0Z"
        fill="currentColor"
      />
    </mask>

    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.222656 26.6363H5.61508V32H9.18986V26.6363H10.9361V32H13.7494V26.6363H18.9188V23.0748H20.776V8.89795H18.9188V5.36221H13.7494V0H10.9361V5.36221H9.20371V0H5.62809V5.36221H0.223113V8.92409H5.62809L5.61508 23.0742H0.222656V26.6363ZM10.941 23.0762H13.7544V19.5116H16.1773V8.92545H10.941V23.0762Z"
      fill="currentColor"
    />
    <defs>
      <clipPath id="clip0_963_28481">
        <rect
          width="21"
          height="32"
          fill="currentColor"
        />
      </clipPath>
    </defs>
  </svg>
</template>